'use client';

import React from 'react';
import Link from 'next/link';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-6">
      <div className="text-center max-w-md">
        <div className="text-8xl font-bold gradient-text-tricolor mb-4">404</div>
        <h1 className="text-2xl font-bold text-indigo mb-2">Page Not Found</h1>
        <p className="font-kannada text-neutral-500 text-sm mb-4">ಪುಟ ಕಂಡುಬಂದಿಲ್ಲ</p>
        <p className="text-neutral-600 mb-8">The page you're looking for doesn't exist or has been moved.</p>
        <Link href="/home" className="px-8 py-3 btn-saffron rounded-full font-semibold text-white">
          Back to Home
        </Link>
      </div>
    </div>
  );
}